import { atom } from "recoil";

export const ALLOWED_EXTERNAL_HOSTS = ["vk", "tg"];
export const REQUIRE_AUTH_OPTIONS = [
	{ value: "0", label: "0" },
	{ value: "1", label: "1" },
];
export const MAX_BANNER_BYTES = 1024 * 1024;

export const normalizeRequireAuthValue = (value) => (String(value) === "1" ? "1" : "0");

export const homeBannersAddModalStore = atom({
	key: "homeBannersAddModalStore",
	default: {
		show: false,
		loaded: false,
		image: "",
		currentOption: {
			buttonType: [
				{ value: "classic", label: "classic" },
				{ value: "main", label: "main" },
				{ value: "white", label: "white" },
			],
			buttonTextType: [
				{ value: "local", label: "local" },
				{ value: "international", label: "international" },
				{ value: "mixed", label: "mixed" },
			],
			linkType: [
				{ value: "internal", label: "internal" },
				{ value: "external", label: "external" },
				{ value: "modal", label: "modal" },
			],
			titleType: [
				{ value: "local", label: "local" },
				{ value: "international", label: "international" },
				{ value: "mixed", label: "mixed" },
			],
			badgeType: [
				{ value: "local", label: "local" },
				{ value: "international", label: "international" },
				{ value: "mixed", label: "mixed" },
			],
			descriptionType: [
				{ value: "local", label: "local" },
				{ value: "international", label: "international" },
				{ value: "mixed", label: "mixed" },
			],
			descriptionDefaultType: [
				{ value: "local", label: "local" },
				{ value: "international", label: "international" },
				{ value: "mixed", label: "mixed" },
			],
			active: [
				{ value: "0", label: "0" },
				{ value: "1", label: "1" },
			],
		},
		buttonTextType: "",
		buttonType: "",
		linkType: "",
		titleType: "",
		badgeType: "",
		descriptionType: "",
		descriptionDefaultType: "",
		active: { value: "0", label: "0" },
		buttonText: "",
		link: "",
		title: "",
		badge: "",
		personalization: false,
		description: "",
		descriptionDefault: "",
		analyticsID: "",
		requireAuth: "0",
		requireTg: false,
		requireEmail: false,
		showUnauthWithDepositLadder: false,
		depositLadderId: null,
		depositLadderStep: null,
		order: "",
		from: "",
		to: "",
		error: {
			text: "",
			code: 0,
			timestamp: 0,
		},
	},
});
